import { toast } from "sonner";
import { Copy } from "lucide-react";
import { cn } from "@/lib/utils";

/** Copy-to-clipboard chip for protocol identifiers (CA, IDs). */
export function CopyButton({
  value,
  label = "COPY",
  className,
  testId,
}: {
  value: string;
  label?: string;
  className?: string;
  testId?: string;
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={async () => {
        try {
          await navigator.clipboard.writeText(value);
          toast("Copied to clipboard", { description: value });
        } catch {
          toast("Copy failed — select the address manually.");
        }
      }}
      className={cn(
        "inline-flex items-center gap-1.5 border border-line px-2 py-1 font-mono text-[9px] uppercase tracking-[0.2em] text-dim transition-colors duration-150 hover:border-cyan/50 hover:text-cyan",
        className
      )}
    >
      <Copy className="h-3 w-3" aria-hidden="true" />
      {label}
    </button>
  );
}
